<swiper
  [config]="config"
  [class.no-top-padding]="noTopPadding"
  [class.no-bottom-padding]="images.length <= 6"
  #swiperSlideShow
  (swiper)="onSwiper($event)"
  (slideChange)="onSlideChange($event)"
>
  <ng-template swiperSlide *ngFor="let image of images; let i = index">
    <div
      class="img-container"
      [ngClass]="isLarge ? 'img-container__large' : 'img-container__normal'"
    >
      <img
        src="{{ image.url }}"
        alt="{{ image.alt }}"
        loading="lazy"
        [ngClass]="isLarge ? 'large' : 'normal'"
      />
    </div>
  </ng-template>
</swiper>
